import { createContext, useContext } from "react";
import type { PermissionCode } from "../utils/permissionHelpers";
import type { NormalizedRole } from "../utils/roleHelpers";

export interface AdminFeatures {
  nameColors: Array<{ id: string; name: string; hexCode: string }>;
  avatarFrames: Array<{ id: string; name: string; imageUrl: string }>;
  selectedColorId?: string | null;
  selectedFrameId?: string | null;
}

export type AdminFeatureFlags = Record<string, boolean>;

export interface AdminSession {
  id: string;
  name: string;
  roles: NormalizedRole[];
  permissions: PermissionCode[];
  avatarUrl?: string;
  features?: AdminFeatures;
  featureFlags?: AdminFeatureFlags;
}

interface AdminSessionState {
  loading: boolean;
  session: AdminSession | null;
}

export const AdminSessionContext = createContext<AdminSessionState>({ loading: true, session: null });

export function useAdminSession(): AdminSessionState {
  return useContext(AdminSessionContext);
}
